module.exports = __webpack_public_path__ + "img/paris-meet-assist.99ab738c.jpg";